<script>
import { onMount } from "svelte";

 
import LoggedIn from "../Components/Auth/LoggedIn.svelte";
import Edit from "../Components/Helpers/Edit.svelte";
import { options } from "../config";
import { loading } from "../loader";
import { PostContact } from "../Services/form0";
import { message_ } from "../Services/messages";
import { user } from "../store";
 

var list ;

onMount(() => {
    loading.set(true);
    PostContact(
        { form: "internal/compliance/assets", profile: options.profile },
        $user.idToken,
        (data) => {
            list = data.app_metadata.list;
            list.forEach((k)=>{
                k.data?.assets.forEach((i)=>{
                    i.sticker=i.sticker||""
                })
            })
            loading.set(false);
        },(error)=>{
            message_.set("You broke something")
            console.log(error)
            loading.set(false)
        }
    );
});

function save(event){
    console.log(event.detail.value,event.detail.uuid)
    const l = list.find((l)=>{
        return l.Key = event.detail.uuid
    })
    const data = {
        contact_uuid:l.Key,
        data:l.data,
        profile:options.profile,
        form:"internal/compliance/checklist",
        no_redirect : true
    }
    PostContact(data,$user.idToken,(result)=>{
        console.log("Saved")
    },(error)=>{
        console.log("Error")
    })
}
</script>

<LoggedIn/>
<div class="section_wrapper">
    <div class="s s100">
        <div class="s s100 box">
            <div class="content_area">
                <h1>Compliance List</h1>
                <table class="form_table">
                    <thead>
                        <tr>
                            <th>Member</th>
                            <th>Serial Number</th>
                            <th>Description</th>
                            <th>Location</th>
                            <th>Owned by</th>
                            <th>Sticker</th> 
                        </tr>
                    </thead>
                    <tbody>
                        {#if list}
                        {#each list as l, i}
                            {#if l.data?.assets}
                                {#each l.data.assets as a,p}
                                <tr>
                                    <td>{l.data.user.email}</td> 
                                    <td>{a.serial_number}</td>
                                    <td>{a.description}</td>
                                    <td>{a.location}</td>
                                    <td>{a.owner}</td>
                                    <td>{a.sticker??""}</td>
                                 <!--   <td><Edit bind:value={a.sticker} on:changed={save} uuid={l.Key}/></td>-->
                                </tr>
                            {/each}
                            {/if}
                        {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>